import React, { useCallback, useState } from 'react';
import './map.css';
import { Container } from './container';
import { MapModal } from '../mapModal';
import { Toolbar } from '../toolbar';
import { mapPlaces } from '../../tools/mapPlaces';
import { Player } from '../Player';
import { HeadToolbar } from '../HeadToolbar';
import { Button } from 'antd';
import { VideoModal } from '../videoModal';
import { MapGlobe } from '../mapGlobe';

export const Map = () => {
  const [isModalOpen, setModalVisibility] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isVideoShowed, setVideoShowed] = useState(false);
  const [isGlobeShowed, setGlobeShowed] = useState(false);
  const [place, setPlace] = useState(null);
  const [activeToolId, setActiveToolId] = useState(null);

  const onToolClick = useCallback(
    (toolId) => {
      if (activeToolId === toolId) {
        setActiveToolId(null);
      } else {
        setActiveToolId(toolId);
      }
    },
    [activeToolId],
  );

  const onMapClick = useCallback((e) => {
    const {
      dataset: { id },
    } = e.target;
    if (id && id === 'SAMARQAND') {
      setIsVideoModalOpen(true);
      return;
    }
    if (id) {
      const place = mapPlaces.find((item) => item.id === id);
      setPlace(place);
      setModalVisibility(true);
    }
  }, []);

  const onContainerGlobeShowed = useCallback(() => {
    setGlobeShowed(true);
    setActiveToolId(null);
  }, []);

  const onMapGlobeShowed = useCallback(() => {
    setGlobeShowed(false);
    setActiveToolId(null);
  }, []);

  return (
    <div className='map_container'>
      <HeadToolbar onToolClick={onToolClick} />
      <div className='map_box'>
        {isVideoShowed ? (
          <Player setVideoShowed={setVideoShowed} />
        ) : isGlobeShowed ? (
          <MapGlobe activeToolId={activeToolId} setGlobeShowed={onMapGlobeShowed} />
        ) : (
          <Container
            setGlobeShowed={onContainerGlobeShowed}
            activeToolId={activeToolId}
            onMapClick={onMapClick}
            setVideoShowed={setVideoShowed}
          />
        )}

        <Toolbar onToolClick={onToolClick} />
      </div>
      {isVideoShowed && (
        <div className='backToMapBox'>
          <Button onClick={() => setVideoShowed(false)}>
            &#8630; Xaritaga qaytish / Back to map
          </Button>
        </div>
      )}
      <VideoModal isVideoModalOpen={isVideoModalOpen} setIsVideoModalOpen={setIsVideoModalOpen} />
      <MapModal place={place} isModalOpen={isModalOpen} setModalVisibility={setModalVisibility} />
    </div>
  );
};
